import { NavLink } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
  <div className="container">

    <NavLink to="/" className="navbar-brand fw-bold">
      Dhanashree Raut
    </NavLink>

    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav ms-auto">

        <li className="nav-item">
          <NavLink exact to="/" className={({isActive}) => `nav-link ${isActive ? "active" : ""}`}>
            Home
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink to="/projects" className={({isActive}) => `nav-link ${isActive ? "active" : ""}`}>
            Projects
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink to="/experience" className={({isActive}) => `nav-link ${isActive ? "active" : ""}`}>
            Experience
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink to="/education" className={({isActive}) => `nav-link ${isActive ? "active" : ""}`}>
            Education
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink to="/about" className={({isActive}) => `nav-link ${isActive ? "active" : ""}`}>
            About Me
          </NavLink>
        </li>

      </ul>
    </div>
  </div>
</nav>

  );
}
